<template>
  <footer>
    <div id="footer-container">
      <div class="footer-item">
        {{ new Date().getFullYear() }} Cambridge University Press
      </div>
      <div class="footer-item">
        <div class="grid">
              <a :href = "PrivacyPolicy" class = "link">
               Privacy Policy
              </a>
              <a :href = "TermsofUse" class = "link">
                Terms of Use
              </a>
              <a :href = "ContactUs" class = "link">
                Contact Us
              </a>
              <a :href = "CookiePolicy" class = "link">
                 Cookie Policy
              </a>
        </div>
      </div>
      <div class="footer-item">
        <div>
          <a :href="facebook" target="_blank" class="link">
            <v-icon>mdi-facebook</v-icon>
          </a>
          <a :href="youtube" target="_blank" class="link">
            <v-icon>mdi-youtube</v-icon>
          </a>
          <a :href="twitter" target="_blank" class="link">
            <v-icon>mdi-twitter</v-icon>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      PrivacyPolicy: 'https://www.cambridge.edu.au/go/privacy/',
      TermsofUse: 'https://www.cambridge.edu.au/go/terms/',
      ContactUs: 'https://www.cambridge.edu.au/go/contact/',
      CookiePolicy: 'https://www.cambridge.edu.au/go/privacy/',
      twitter: 'https://www.twitter.com/CUPeducation',
      facebook: 'https://www.facebook.com/CUPeducation',
      youtube: 'https://www.youtube.com/CambridgeUPedu'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

footer {
  position: relative;
  background-color: $primary-dark;
  color: #fff;
  padding: 50px;
  #footer-container {
    max-width: 1800px;
    margin: auto;
    display: grid;
    grid-template-columns: 3fr 2fr 1fr;
    align-items: start;
    .footer-item:first-child {
      padding-left: 10px;
      font-size: 14px;
    }
    .footer-item:nth-child(2) {
      font-size: 14px;
      .grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        align-items: center;
        grid-gap: 5px;
        .link {
          text-decoration: none;
          color: #fff;
          transition: color 0.3s;
          padding: 5px;

          &:hover {
            color: $secondary;
          }
        }
        .contact-us {
          text-align: center;
          border-style: solid;
          border-color: #fff;
          border-radius: 50px;
          border-width: 1.5px;
          transition: color, background-color 0.3s;
          &:hover {
            background-color: $secondary;
            color: #fff;
          }
        }
      }
    }
    .footer-item:last-child {
      display: flex;
      position: relative;
      div {
        position: absolute;
        right: 0;
        .link {
          text-decoration: none;
          .v-icon {
            color: #fff;
            font-size: 30px;
            transition: color 0.3s;
            padding: 0px 10px;
            &:hover {
              color: $secondary;
            }
          }
        }
      }
    }
  }
}

//SMARTPHONES
@media (max-width: 750px) {
  footer {
    padding: 30px;
    #footer-container {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      .footer-item:first-child {
        padding: 5px;
        font-size: 12px;
        font-weight: 100;
      }
      .footer-item:nth-child(2) {
        .grid {
          grid-template-columns: repeat(2, 1fr);
          grid-template-areas:
            ' privacy accessibility '
            ' terms contact ';
          .link {
            font-size: 12px;
          }
          .link:nth-child(1) {
            grid-area: privacy;
          }
          .link:nth-child(2) {
            grid-area: terms;
          }
          .link:nth-child(3) {
            grid-area: contact;
          }
          .link:nth-child(4) {
            grid-area: accessibility;
          }
        }
      }
      .footer-item:last-child {
        div {
          position: inherit;
          .link {
            .v-icon {
              padding: 0px;
              font-size: 20px;
              &:first-child {
                padding-right: 20px;
              }
            }
          }
        }
      }
    }
  }
}
//TABLETS
@media (min-width: 751px) and (max-width: 1100px) {
  footer {
    #footer-container {
      grid-template-columns: 1.5fr 1.5fr 1fr;
      .footer-item:first-child {
        font-size: 12px;
      }
      .footer-item:nth-child(2) {
        .grid {
          grid-template-columns: repeat(2, 1fr);
          grid-template-areas:
            ' privacy contact '
            ' terms contact '
            ' accessibility accessibility ';
          .link {
            font-size: 12px;
          }
          .link:nth-child(1) {
            grid-area: privacy;
          }
          .link:nth-child(2) {
            grid-area: terms;
          }
          .link:nth-child(3) {
            grid-area: contact;
          }
          .link:nth-child(4) {
            grid-area: accessibility;
          }
        }
      }
    }
  }
}
</style>
